import { useEffect, useState } from 'react';

export type Duration = {
  milliseconds: number;
  seconds: number;
  minutes: number;
  hours: number;
  duration: number;
};

function msToTime(duration: number): Duration {
  const milliseconds = Math.floor((duration % 1000) / 100);
  const seconds = Math.floor((duration / 1000) % 60);
  const minutes = Math.floor((duration / (1000 * 60)) % 60);
  const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  return {
    milliseconds,
    seconds,
    minutes,
    hours,
    duration,
  };
}

const useCountdown = (to: number | Date, tick = 1000, shouldRun = true) => {
  const destionation = typeof to === 'number' ? to : to.getTime();
  const [delta, setDelta] = useState(destionation - Date.now());

  useEffect(() => {
    if (shouldRun) {
      const interval = setInterval(() => {
        const now = Date.now();
        const newDelta = destionation - now;
        setDelta(newDelta);
      }, tick);

      return () => clearInterval(interval);
    }

    return undefined;
  }, [destionation, tick, shouldRun]);

  return msToTime(delta);
};

export default useCountdown;
